import { render, staticRenderFns } from "./ErpIcmRoomAccess.vue?vue&type=template&id=107d4262&scoped=true&"
import script from "./ErpIcmRoomAccess.vue?vue&type=script&lang=js&"
export * from "./ErpIcmRoomAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107d4262",
  null
  
)

export default component.exports